<div class="m-2 alert alert-danger d-flex justify-content-between" role="alert">
    <div>
        <strong class="me-auto">Unauthorized</strong>
        please contact the developers, thank you
    </div>
    <!-- <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> -->
</div>